import angular from 'angular';
import adminReportsRoutingModule from './admin-reports-routing-module';
import adminReportsPageModule from './components/admin-reports-page/admin-reports-page-module';
import userActivityReportsModule from './components/user-activity-reports/user-activity-reports-module';
import adminReportsFilterModule from './components/admin-reports-filter/admin-reports-filter-module';

export default angular.module('admin-reports', [
  adminReportsRoutingModule.name,
  adminReportsPageModule.name,
  userActivityReportsModule.name,
  adminReportsFilterModule.name,
]);



// WEBPACK FOOTER //
// ./src/modules/admin-reports/admin-reports-module.js